var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a963456963"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8E2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0CDFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "b963456963"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8E2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0CDFF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.527 5.286c-.34 0-.79-.007-1.351-.007-1.368 0-2.492-1.132-2.492-2.512V.346A.343.343 0 0 0 7.344 0H3.36C1.502 0 0 1.525 0 3.395v8.113c0 1.961 1.574 3.55 3.516 3.55h5.93c1.853 0 3.354-1.515 3.354-3.386V5.625a.341.341 0 0 0-.34-.345c-.319.003-.7.006-.933.006",
    fill: "url(#a963456963)",
    transform: "translate(1.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.475.427a.36.36 0 0 0-.618.252v1.985c0 .833.686 1.518 1.519 1.518.524.006 1.253.008 1.872.006.317 0 .478-.38.258-.608-.794-.826-2.216-2.307-3.031-3.153",
    fill: "url(#b963456963)",
    transform: "translate(1.333)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.554 9.708a.561.561 0 0 1 0 1.12h-4.1a.56.56 0 1 1 0-1.12h4.1zm-1.55-3.76a.561.561 0 0 1 0 1.12h-2.55a.56.56 0 1 1 0-1.12h2.55z",
    fill: "#004CC4",
    id: "c963456963"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.d76b61be.svg";
export { ForwardRef as ReactComponent };